module.exports = __webpack_public_path__ + "images/ghost.546eed22.jpg";